enum DragType {
  PERSPECTIVE = 'PERSPECTIVE',
}

export default DragType;
